import type { FaireRetailerEntity } from "../../entity_types/retailer";

export const r_rk3595bqqg: FaireRetailerEntity = {
  token: "r_rk3595bqqg",
  type: "retailer",
  name: "Time and the Bell",
  themeTokens: [
    "coastal-california-gifting",
    "spa-night-self-care",
    "under-20-add-on-wins",
    "paper-goods-planning",
    "modern-host-home-gifts",
    "desk-candy-bag-charms",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:42Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
